// Recovered compiled webpack factory 75601. Edit this function expression; run npm run build.
(t, e, i) => {
  i.d(e, { xQ: () => r });
  var n = i(12115),
    s = i(59686);
  function r() {
    let t = !(arguments.length > 0) || void 0 === arguments[0] || arguments[0],
      e = (0, n.useContext)(s.t);
    if (null === e) return [!0, null];
    let { isPresent: i, onExitComplete: r, register: o } = e,
      a = (0, n.useId)();
    (0, n.useEffect)(() => {
      if (t) return o(a);
    }, [t]);
    let l = (0, n.useCallback)(() => t && r && r(a), [a, r, t]);
    return !i && r ? [!1, l] : [!0];
  }
}
